import script from "./ExcellenceAndDiscountPromotionTerminal.vue?vue&type=script&setup=true&lang=js"
export * from "./ExcellenceAndDiscountPromotionTerminal.vue?vue&type=script&setup=true&lang=js"

import "./ExcellenceAndDiscountPromotionTerminal.vue?vue&type=style&index=0&id=2b0506dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b0506dc"]])

export default __exports__